<label *ngIf="!!label">
  <span *ngIf="IsRequired" class="required-asterisk">*</span>
  <span>{{ label }}</span>
</label>

<span class="hint">
  {{ "shared.MaxSize" | translate }} {{ maxSizeInMB }}
  {{ "shared.MB" | translate }}
  {{ "shared.AllowedExtensions" | translate }}
  {{ allowedExtensions.join(", ").toUpperCase() }}
</span>

<div class="input-container btn__secondary" style="width: 100px; min-width: 100px" appDnd
  (fileDropped)="onFileDropped($event)" *ngIf="isShowInput" tabindex="0" (keydown.enter)="fileDropRef.click()" (keydown.space)="fileDropRef.click()">
  <input type="file" #fileDropRef id="fileDropRef" [multiple]="isMultiple" (click)="resetInput($event)"
    (change)="fileBrowseHandler($any($event).target.files)" style="display: none;" />
  <!-- <img src="./assets/images/cloud_upload.svg" alt="" /> -->
  <label for="fileDropRef" class="mb-0">
    <p [innerHTML]="'shared.uploadFiles' | translate"></p>
  </label>
</div>

<div class="files-list" *ngIf="AllFiles && AllFiles.length" [ngStyle]="{ margin: isMultiple ? '15px 0' : 'unset' }">
  <div class="single-file" *ngFor="let file of files; let i = index">
    <div class="file-icon">
      <mat-icon class="success-icon">check_circle</mat-icon>

    </div>
    <div class="info">
      <h4 class="name">
        {{ file?.name }}
      </h4>

    </div>
    <div class="actions">
      <button class="delete" type="button" 
      aria-label="deleteFile"

      (click)="deleteFile(i)" *ngIf="!isViewMode">
      <img src="assets/images/close.svg" alt="" srcset="">
        <!-- <mat-icon>close</mat-icon> -->
      </button>
    </div>
  </div>
  <div class="single-file" *ngFor="let file of previousFiles; let i = index">
    <div class="file-icon" >
            <mat-icon class="success-icon">check_circle</mat-icon>

    </div>
    <div class="info">
      <h4 class="name" (click)="showFile(file)">
        {{ file?.fileName }}
      </h4>
    </div>
    <div class="actions">
      <button class="delete" aria-label="deleteFile" (click)="deleteUploadedFile(file)" *ngIf="!isViewMode">
        <mat-icon>close</mat-icon>
      </button>

    </div>
  </div>
</div>

<div class="error mt-2" *ngIf="ShowError">
  <validations [control]="control"></validations>
</div>
